var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3391 12.4685C20.3391 11.9991 19.9586 11.6185 19.4891 11.6185L6.21168 11.6185C5.74224 11.6185 5.36168 11.9991 5.36168 12.4685C5.36168 12.938 5.74224 13.3185 6.21168 13.3185L19.4891 13.3185C19.9586 13.3185 20.3391 12.938 20.3391 12.4685Z",
    fill: "#A51713"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1289 6.88846C9.79693 6.55651 9.25874 6.55651 8.92679 6.88846L4.63194 11.1833C3.90947 11.9058 3.90947 13.0771 4.63194 13.7996L8.90711 18.0748C9.23905 18.4067 9.77724 18.4067 10.1092 18.0748C10.4411 17.7428 10.4411 17.2046 10.1092 16.8727L5.83402 12.5975C5.77544 12.5389 5.77544 12.444 5.83402 12.3854L10.1289 8.09054C10.4608 7.75859 10.4608 7.2204 10.1289 6.88846Z",
    fill: "#A51713"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon_arrow_left.68b440f998e4d288ea27f164fe66f526.svg";
export { ForwardRef as ReactComponent };